<template>
  <q-card>
    <q-toolbar>
      <q-toolbar-title class="text-center">
        Accept Invitation
      </q-toolbar-title>
    </q-toolbar>
    <q-separator />
    <form @submit.prevent="accept">
      <q-card-section>
        <p>Your user account is almost setup!</p>
        <p>Please enter your desired password:</p>
        <password-input
          label="Password"
          v-model="password"
          outlined
        />
      </q-card-section>
      <q-card-actions align="center">
        <async-btn
          type="submit"
          label="Continue"
          :task="task"
          color="primary"
          class="full-width"
        />
      </q-card-actions>
    </form>
  </q-card>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import notify from '@/components/notify';
import PasswordInput from '@/components/form/PasswordInput.vue';
import AsyncBtn from '@/components/AsyncBtn.vue';
import { login } from '@/auth/auth';
import { decodeJWT } from '@/utils';
import { acceptInvite } from './user';

interface Data {
  email: string,
  password: string,
  task: Promise<void>|null,
}

function getEmailFromToken(token: string): string {
  const claims = (decodeJWT(token) as { data: { email: string}});
  return claims.data.email;
}

export default defineComponent({
  meta: {
    title: 'Accept Invitation',
  },
  components: {
    PasswordInput,
    AsyncBtn,
  },
  props: {
    token: {
      type: String,
      required: true,
    },
  },
  data(): Data {
    return {
      email: getEmailFromToken(this.token),
      password: '',
      task: null,
    };
  },
  methods: {
    accept() {
      this.task = acceptInvite(this.token, this.password);
      this.task.then(() => {
        const command = { email: this.email, password: this.password, remember: false };
        login(command).then(() => {
          this.$router.push({ name: 'dashboard' });
        });
        notify('Your user account has been setup.');
      });
    },
  },
});
</script>
